// extracted by mini-css-extract-plugin
export default {"control":"CheckoutComplete_control__+wX+M","row":"CheckoutComplete_row__KhxJv","col":"CheckoutComplete_col__d0xUe"};